ch-notifications {
  --ch-notification-item-rtl-initial-X: 10px;
  --ch-notification-item-rtl-initial-Y: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: fixed;
  width: 425px;
  max-width: 75vw;
}
ch-notifications[y-align=outside-start] {
  inset-block-start: var(--ch-notification-item-rtl-initial-Y);
}
ch-notifications[x-align=outside-start] {
  inset-inline-start: var(--ch-notification-item-rtl-initial-X);
}
ch-notifications[x-align=center] {
  inset-inline-start: 50%;
  transform: translateX(-50%);
}
ch-notifications[x-align=outside-end] {
  inset-inline-end: var(--ch-notification-item-rtl-initial-X);
}
ch-notifications[y-align=outside-end] {
  inset-block-end: var(--ch-notification-item-rtl-initial-Y);
}